import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { router } from 'umi';
import withRouter from 'umi/withRouter';
import { Toast } from 'antd-mobile';
import { connect } from 'dva';
import { parseDate, daysDistance, greaterThanNow } from '@/utils/time';
import NavBar from '@/components/NavBar';
import Icon from '@/components/Icon';
import TimeTab from '@/components/TimeTab';
import SessionItem from '@/components/SessionItem';
import Notice from '@/components/Notice';
import PullLoad from '@/components/PullLoad';
import api from '@/common/api';
// import {getMovieDeatil} from '@/entity/module/movieDetail/indexAPi'
import { CinemaProps } from '@/entity/module/cinema/index';
import { ITimeTabItem, ICinemaMovieSessionInfo, IMovieItem } from '@/interface/index';
import { sessionQuery } from '@/interface/req';
import { filterTimeGreaterThanNow } from '@/utils/func';
import { replaceNullToString } from '@/utils/commonHelper';
import DfSwiper from '@/components/dFSwiper';
import styles from './index.less';

import inf from '../../assets/imgs/info_outline.png';
import pz from '../../assets/imgs/location.png';
import placeholderImg from '../../assets/imgs/placeholderimg.png';
// import DFCarousel from '@/components/dFCarousel';
import { getQueryString, unionFlag, checkUnifyShop } from '@/utils';
import { checkXcx } from '@/utils/checkXcx';
import SuspendServe from '@/components/SuspendServe';
import nodataIcon from '../../assets/imgs/nodata@2x.png';
import { TLang, getCookie } from '@/utils/lang';
import { CinemaDetailSkeleton, CinemaDetailTabSkeleton } from '@/components/skeleton';
import { Modal } from 'antd-mobile';
import DfPrice from '@/components/dFPrice';
import homeReq from '@/entity/module/home/homeAPi';
import { BFD_checkApp, BFD_LoginOut } from '@/utils/bfdApp';
import { increaseLoading, decreaseLoading, timer as timeFunc } from '@df-mobile/library2';
import { gioClick } from '@/utils/gioApi';
import DfIcon from '@df-mobile/df-icon';
import { useMemoizedFn } from 'ahooks';


interface IDistrictObj {
  id: number;
  cinemaCount: number;
  name: string;
  districtId?: number;
}
let timer = null;
const CinemaSessionList = (props: CinemaProps) => {

  const [showInitSkeleton, setShowInitSkeleton] = useState(true);
  const [showTabSkeleton, setShowTabSkeleton] = useState(false);
  // 影院ID
  const [cimemaId, setCimemaId] = useState(props.history.location.query.cid);
  const [mId, setMId] = useState(props.history.location.query.mid || null);
  // 页码
  const [pageIndex, setPageIndex] = useState<number>(1);

  // 电影详情数据
  const [cinemaData, setCinemaData] = useState<any>();
  // session List
  const [sessionData, setSessionData] = useState<any>();

  const [timeMenuTop, setTimeMenuTop] = useState(0);

  // 时间
  const [timeTabArr, setTimeTabArr] = useState<Array<ITimeTabItem>>();
  const [showDateItem, setShowDateItem] = useState<ITimeTabItem | null>(null);
  const [discountShowDates, setDiscountShowDates] = useState<any[]>([]);


  const [selectedMovie, setSelectedMovie] = useState<IMovieItem | null>();
  const [mIndex, setMIndex] = useState(0);
  // getTimeMenuAndQuerySession

  const [showTicketModal, setShowTicketModal] = useState<boolean>(false);
  const [currentSessionInfo, setCurrentSessionInfo] = useState<any>();

  // 临近120分钟时间拦截
  const [endBuyTime2, setEndBuyTime2] = useState();

  useEffect(() => {
    const d: any = document.querySelector('.timeMenu');
    const timeNavTop = d?.offsetTop || 0;
    setTimeMenuTop(timeNavTop);
  }, [cinemaData, selectedMovie]);

  const scrollToTop = () => {
    const d: any = document.querySelector('.navBarContainer');
    const barHei = d?.offsetHeight || 0;
    if (timeMenuTop > barHei) {
      // console.log(timeMenuTop,barHei)
      window.scrollTo(0, timeMenuTop - barHei);
    }
  };
  useEffect(() => {
    // if (props?.cinemaParams?.cimemaId) {
    //   setCimemaId(props?.cinemaParams?.cimemaId);
    // }
    // if (props?.cinemaParams?.mId) {
    //   setMId(props?.cinemaParams?.mId);
    // }
  }, [props.cinemaParams]);

  // 请求影片的某个日期下的拍片。并且过滤 showDate 在现在之前的
  const querySessionList = (q: sessionQuery, more: boolean = false) => {
    q.pageSize = 20;
    if(!more) {
      setShowTabSkeleton(true);
    }
    return Promise.resolve().then(() => api.getSessionList(q).finally(() => {
      if(!more) {
        setShowTabSkeleton(false);
      }
    }).then((res) => {
        if (!res) {
          return;
        }
        let sessions = filterTimeGreaterThanNow(res.searches);
        if (more === true) { // load more
          setSessionData({ totalCount: res.totalCount, hasNext: res.hasNext, searches: [...sessionData.searches, ...sessions] });
          setPageIndex(pageIndex + 1);
        } else {
          setSessionData({ totalCount: res.totalCount, hasNext: res.hasNext, searches: sessions });
        }
        return res;
      }));
  };

  // 点击了时间
  const timeHandle = (s: any, idx?: number) => {
    // console.log(s, idx);
    setPageIndex(1);
    const param: sessionQuery = {};
    if (typeof idx === 'undefined') { // 1+
      const idx = timeTabArr?.findIndex((i) => i.origin === s?.origin);

      const nextIdx = idx;
      const newArr = timeTabArr?.map((ite, index) => {
        if (index === nextIdx) {
          ite.status = true;
        } else {
          ite.status = false;
        }
        return ite;
      });
      const i = newArr?.find((ite) => ite.status === true) || null;
      setTimeTabArr(newArr);
      setShowDateItem(i);
      param.cinemaId = cimemaId;
      param.showDate = i?.origin;
      param.movieId = selectedMovie?.id;
      param.pageIndex = 1;
    } else { // 0
      setShowDateItem(s);
      param.cinemaId = cimemaId;
      param.showDate = s?.origin;
      param.movieId = selectedMovie?.id;
      param.pageIndex = 1;
    }
    querySessionList(param);
    // scrollToTop();
  };

  // const updateDiscount = () => {
  //   try {
  //     api.getCinema(cimemaId).finally(() => {
  //       setShowInitSkeleton(false);
  //     }).then((res) => {
  //       if (res && Array.isArray(res?.movies)) {
  //         const current = res?.movies.filter((item) => item.id === selectedMovie?.id);
  //         if (current[0]?.discountShowDates) {
  //           setDiscountShowDates(current[0]?.discountShowDates);
  //           if (!res || !res.movies) {
  //             console.log(current[0]?.discountShowDates);
  //           };
  //         }
  //       }
  //     })
  //   } catch (err) {
  //     console.log(err)
  //   }
  // }


  const changeToNextDate = () => {
    setPageIndex(1);
    const idx = timeTabArr?.findIndex((i) => i.origin === showDateItem?.origin) || 0;
    const nextIdx = idx + 1;
    if (nextIdx === timeTabArr?.length) {
      return;
    }
    const newArr = timeTabArr?.map((ite, index) => {
      if (index === nextIdx) {
        ite.status = true;
      } else {
        ite.status = false;
      }
      return ite;
    });
    const i = newArr?.find((ite) => ite.status === true) || null;
    setTimeTabArr(newArr);
    setShowDateItem(i);

    const param: sessionQuery = {};
    param.cinemaId = cimemaId;
    param.showDate = i?.origin;
    param.movieId = selectedMovie?.id;

    querySessionList(param);
  };

  const getTimeMenuAndQuerySession = (movie) => {
    // console.log(movie,mIndex);

    if (!movie || movie.showDates.length === 0) {
      return;
    }
    // 默认选中第一个 movie 的数据
    let arr: Array<ITimeTabItem> = [];
    movie.showDates.forEach((i) => {
      const d = daysDistance(i);
      if (d > -1) {
        const info: ITimeTabItem = parseDate(i);
        arr.push(info);
      }
    });
    setTimeTabArr(arr);
    if (arr.length === 0) {
      return;
    }
    // 影片详情带过来的时间
    const defaultSelectDate = getQueryString('date');
    const selectDate = arr.find((item) => item.origin === defaultSelectDate);
    arr.length && arr.forEach((item, idx) => {
      item.status = false;
      // 有匹配到
      if (selectDate && item.origin === defaultSelectDate) {
        item.status = true;
      }
      // 没匹配到，默认选中第一项
      if (idx == 0 && !selectDate) {
        item.status = true;
      }
    });
    const param: sessionQuery = {};
    param.cinemaId = cimemaId;
    // param.showDate = arr[0].origin;
    param.movieId = movie.id;
    if (defaultSelectDate && selectDate) {
      setShowDateItem(selectDate);
      param.showDate = selectDate.origin;
    } else {
      setShowDateItem(arr[0]);
      param.showDate = arr[0].origin;
    }
    querySessionList(param);
  };

  const gotoCinemaDetail = () => {
    // 获取 id .请求数据

    router.push({
      pathname: '/cinemaDetail',
      query: {
        id: cimemaId
      }
    });

  };
  const gotoCinemaLocation = () => {
    // console.log('gotoCinemaLocation')
    if (checkXcx()) {
      let param = JSON.stringify({
        latitude: Number(cinemaData.latitude),
        longitude: Number(cinemaData.longitude),
        name: cinemaData.name,
        address: cinemaData.zhAddress
      });
      const _win: any = window;
      _win.wx.miniProgram.navigateTo({
        url: '/packageF/map/map?cinema=' + param
      });
    } else {
      router.push({
        pathname: '/map',
        query: {
          name: cinemaData.name,
          addr: cinemaData.zhAddress,
          latitude: cinemaData.latitude,
          longitude: cinemaData.longitude
        }
      });
    }
  };
  const sesstionHandleClick = async (item, idx) => {
    try {
      gioClick('电影-影院详情', {
        pagename: '影院详情',
        modulename: '影院详情列表',
        elementname: '购票',
        floorNum: 4,
        HPbanenrNum: idx + 1,
        JumpAddress: window.location.origin + '/movieSeat',
        channle: '电影',
        cinemaName: cinemaData?.name,
        name: selectedMovie?.name,
        showDate: showDateItem?.label,
        showDateTime: item?.showDateTime,
        cinemaCode: cinemaData?.nationCode,
        price: item?.price / 100
      });
    } catch (error) {
      console.error(error);
    }
    // console.log(item, idx);
    setEndBuyTime2(item?.endBuyTime2);
    const p: ICinemaMovieSessionInfo = {};
    p.cinemaId = item.cinemaId;
    p.cinemaName = cinemaData.name;
    p.movieId = item.movieId;
    p.movieName = selectedMovie?.name;
    p.showDateTime = item.showDateTime;
    p.duration = item.duration;
    p.hallName = item.hallName;
    p.language = item.language;
    p.hallEnName = item.hallEnName;
    p.enLanguage = item.enLanguage;
    p.dimensional = item.dimensional;
    p.dfScheduleId = item.dfScheduleId;
    p.cityId = cinemaData.cityId;
    p.districtId = cinemaData.districtId;
    p.lowPriceTag = false;
    p.isVendor2Single = item.isVendor2Single;
    p.btnType = 0;
    increaseLoading();
    timeFunc(5000).finally(() => {
      decreaseLoading();
    });
    const res = await api.getCattlePurchaseLimit(p);
    decreaseLoading();
    if (!res) return ;
    // save to dva
    // console.log('props.dispatch', props.dispatch);
    props.dispatch && props.dispatch({ type: 'cinema/SetMovieSession', payload: p });
    //上面 没有callback 最好异步
    if (item?.price2) {
      setShowTicketModal(true);
      setCurrentSessionInfo(item);
    } else {
      Promise.resolve().then(() => {
        router.push({
          pathname: '/movieSeat'
        });
      });
    }
  };


  const changeMovieIndex = useMemoizedFn((index: number) => {
    if (cinemaData.movies.length <= 0) {
      return;
    }
    setSelectedMovie(cinemaData.movies[index]);
    props.dispatch && props.dispatch({ type: 'cinema/setMId', payload: cinemaData.movies[index].id });
    const { pathname, query = {} } = props.history.location;
    const nUrl = `${pathname}?cid=${query.cid}&date=${query.date}&mid=${cinemaData.movies[index].id}`;
    props.history.replace(nUrl);
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      // setSelectedMovie(replaceNullToString(cinemaData.movies[index]));
      // 默认选中第一个moive 的时间数据 请求它的排期
      console.log(index);
      getTimeMenuAndQuerySession(cinemaData.movies[index]);
      setDiscountShowDates(cinemaData.movies[index]?.discountShowDates);
    }, 100);

  });

  // 获取电影详情 -> 解析时间 -> 获取商圈 -> 获取影院列表
  useEffect(() => {
    // request movie data
    api.getCinema(cimemaId).finally(() => {
      setShowInitSkeleton(false);
    }).then((res) => {

      if (!res || !res.movies) return;

      if (res.movies && res.movies.length === 0) {
        // Toast.info('院没有影片排期');
        console.log('该影院没有影片排期');
      }
      if (res.movies && res.movies.length > 0) {
        // 交换
        let movies_1 = res.movies.slice();
        if (movies_1 && movies_1.length > 2) {
          const movies_2 = movies_1.slice(0);
          // 根据影片id找到影片，放在index=1的位置，防止在轮播图中不断滚动寻找影片。增强用户体验
          let tarIndex = movies_1.findIndex((item: any, index: number) => {
            if (item.id == mId) {
              return true;
            }
            return false;
          });
          tarIndex = tarIndex == -1 ? 1 : tarIndex;
          movies_2.splice(tarIndex, 1);
          movies_2.splice(1, 0, movies_1[tarIndex]);
          res.movies = movies_2;
        } else if (movies_1 && movies_1.length === 2) {
          res.movies = [movies_1[1], movies_1[0]];
        }
      }

      setCinemaData(res);
      if(res?.snackFeature?.snackPage) {
        const union = unionFlag() || sessionStorage.getItem('dffl_union') || sessionStorage.getItem('film_dffl_union');
        let url = '';
        if (union || checkUnifyShop()){
          url = window.location.origin + res?.snackFeature?.snackPage?.hrefBfdH5;
        } else {
          url = window.location.origin + res?.snackFeature?.snackPage?.hrefGWH5;
        }
        gioClick('电影-影院详情', {
          pagename: '影院详情',
          modulename: '轮播',
          elementname: '轮播',
          content: '电影小食',
          floorNum: 3,
          HPbanenrNum: 1,
          JumpAddress: url,
          channle: '电影',
          cinemaName: cinemaData?.name,
          name: selectedMovie?.name
        }, 'DF_exposureEvent');
      }

      let mov;
      // mid影片id存在，就选中该影片
      if (mId && res.movies.length > 1) {
        let idx = 0;
        const mObj = res.movies.find((item: any, index: number) => {
          if (item.id == mId) {
            idx = index;
            return true;
          }
          return false;
        });
        if (mObj) {
          mov = mObj;
          setMIndex(idx);
          // setSelectedMovie(replaceNullToString(mObj));
          setSelectedMovie(mObj);
        } else if (res.movies[1]) {
          mov = res.movies[1];
          setMIndex(1);
          // setSelectedMovie(replaceNullToString(res.movies[1])); // 当数据存在问题。做一个容错
          setSelectedMovie(res.movies[1]); // 当数据存在问题。做一个容错

        }
      } else if (res.movies.length > 1) { // 默认选中第2个 movie 的数据
        mov = res.movies[1];
        setSelectedMovie(res.movies[1]);
        // setSelectedMovie(replaceNullToString(res.movies[1]));
        setMIndex(1);
      } else if (res.movies.length > 0) {
        mov = res.movies[0];
        setSelectedMovie(res.movies[0]);
        // setSelectedMovie(replaceNullToString(res.movies[0]));
        setMIndex(0);
      }

      // 默认选中第一个moive 的时间数据 请求它的排期
      // res.movies && res.movies.length > 0 && getTimeMenuAndQuerySession(mov);
    });
  }, [props.currentAddress]);
  // getTimeMenuAndQuerySession
  const loadMoreData = () => {
    // load more session list
    const param: sessionQuery = {};
    param.cinemaId = cimemaId;
    param.showDate = showDateItem?.origin;
    param.movieId = selectedMovie?.id;
    param.pageIndex = pageIndex + 1;
    param.pageSize = 20;
    querySessionList(param, true);
  };
  //  去锁座
  const goToLockTicket = (lowPriceTag: boolean) => {
    props.dispatch && props.dispatch({ type: 'cinema/SetMovieSession', payload: {
      lowPriceTag,
      btnType: lowPriceTag ? 3 : 2
    } });
    let s: boolean  = true;
    if (lowPriceTag) {
      s = greaterThanNow(endBuyTime2);
    } else {
      if(currentSessionInfo?.endBuyTime){
        s = greaterThanNow(currentSessionInfo?.endBuyTime);
      }else if(currentSessionInfo?.showDateTime){
        s = greaterThanNow(currentSessionInfo?.showDateTime, 30);
      }
    }
    if(s){
      const isBFDAPP = BFD_checkApp();
      if(isBFDAPP) {
        homeReq.getLoginStatus().then((res) => {
          if(res?.loginFlag===0){
            BFD_LoginOut();
          } else {
            setShowTicketModal(false);
            Promise.resolve().then(() => {
              router.push({
                pathname: '/movieSeat'
              });
            });
          }
        });
      } else {
        setShowTicketModal(false);
        Promise.resolve().then(() => {
          router.push({
            pathname: '/movieSeat'
          });
        });
      }
    } else {
      Toast.info(TLang('当前场次已过抢折扣时间，请重新购票。', 'home', false, false, null));
      // window.location.reload();
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }

  };

  /**跳到小食活动页 */
  const gotoSnackClick = (info: any) => {
    const union = unionFlag() || sessionStorage.getItem('dffl_union') || sessionStorage.getItem('film_dffl_union');
    let url = '';
    if (union || checkUnifyShop()){
      url = window.location.origin + info?.hrefBfdH5;
    } else {
      url = window.location.origin + info?.hrefGWH5;
    }
    try {
      gioClick('电影-影院详情', {
        pagename: '影院详情',
        modulename: '轮播',
        elementname: '轮播',
        content: '电影小食',
        floorNum: 3,
        HPbanenrNum: 1,
        JumpAddress: url,
        channle: '电影',
        cinemaName: cinemaData?.name,
        name: selectedMovie?.name
      });
    } catch (error) {
      console.error(error);
    }
    if (union || checkUnifyShop()){
      window.df_sdk_common.location.href = info?.hrefBfdH5;
    } else {
      window.df_sdk_common.location.href = info?.hrefGWH5;
    }
  };


  if (showInitSkeleton) {
    return <CinemaDetailSkeleton></CinemaDetailSkeleton>;
  }
  return <>
    {/* 单独提取header，防止transform影响 */}
    {cinemaData && (
      <NavBar initColor="#2B3C4D" text={cinemaData.name || ''} textStyles={{ color: '#999' }} targetColor="#2B3C4D" targetBgColor="#FFF" opacity={1} />
    )}
    {/* ios 12合成层渲染问题，transform独立渲染一层 */}
    <div className={`${styles.cinameContainer} cinemaDetail`}>
      {
      cinemaData ? <>
        <div className={styles.placehodelWrapper}></div>
        <div className={styles.container}>
          {
            cinemaData && cinemaData.notice ?
              <div className={styles.noticeWrapper}> <Notice text={cinemaData.notice} /></div> : null
          }
          <div className={styles.infoWrapper}>
            <div className={styles.left} onClick={gotoCinemaDetail}>
              <div className={styles.name}>{cinemaData.name}</div>
              <div className={styles.addr}>{cinemaData.address}</div>
              <div className={styles.feature}>
                {cinemaData?.snackFeature?.name && <span className={styles.orangeColor}>{cinemaData?.snackFeature?.name}</span>}
                {cinemaData.features && cinemaData.features.map((i, idx) => <span key={idx}>{i.name}</span>)}
              </div>
            </div>
            <div className={styles.right}>
              <div className={styles.arrow} onClick={gotoCinemaDetail}>
                <Icon
                  type="order_selectdate_more"
                  size="md"
                  color="#B2B2B2"
                />
              </div>
              {
                cinemaData.latitude && cinemaData.longitude ?
                  <span className={styles.position} onClick={gotoCinemaLocation}>
                    <DfIcon type={'IconFont'} iconUrl="icon-dingwei" iconColor={window?.dffl_global?.allCommonTheme?.globalThemeColor} />
                  </span>
                // <img className={styles.position} src={pz} alt="" onClick={gotoCinemaLocation} />
                : null
              }
            </div>
          </div>
          {
            cinemaData && cinemaData.movies.length > 0 ?
              <div className={styles.moviesContainer}>
                <img className={styles.bgimg} src={selectedMovie?.logo || placeholderImg} alt="" />
                <div className={styles.mask}></div>
                <div className={styles.movieInfoContainer}>
                  <div className={styles.scrollOutWrapper}>
                    <DfSwiper data={cinemaData.movies} initIndex={mIndex} movieCount={cinemaData?.movies?.length} callBack={changeMovieIndex} />
                    {/* <DFCarousel data={cinemaData.movies} initIndex={mIndex} callBack={changeMovieIndex} ></DFCarousel> */}
                  </div>
                  {
                    selectedMovie && <div className={styles.info}>
                      <span>{selectedMovie.name}</span>
                      <span>{`${selectedMovie.duration}${TLang('分钟', 'home', false, false, null)}`}<i>/</i>{selectedMovie.type && selectedMovie.type.replace(/\//g, '、')}<i>/</i>{selectedMovie.actor && selectedMovie.actor.replace(/\//g, '、')}</span>
                      {
                        selectedMovie.alert ? <div className={styles.selAlert}><img src={inf} /> <span>{selectedMovie.alert}</span></div> : null
                      }
                    </div>
                  }
                </div>
              </div> : <SuspendServe
                msg={TLang('当前影院暂无电影排片', 'home', false, false, null)}
                img={nodataIcon}
                mHieght={null}
                       ></SuspendServe>
          }
        </div>
        {cinemaData?.snackFeature?.snackPage && <div className={styles.snackImg} onClick={() => gotoSnackClick(cinemaData?.snackFeature?.snackPage)}>
          <img src={cinemaData?.snackFeature?.snackPage?.imgH5} alt="" /></div>}
        {timeTabArr ? (
          <div className={`${styles.timeMenuWrapper} timeMenu`}>
            <TimeTab discountShowDates={discountShowDates} data={timeTabArr} onClick={timeHandle} />
          </div>
        ): null}
        {showTabSkeleton && <CinemaDetailTabSkeleton></CinemaDetailTabSkeleton>}
        {
          !showTabSkeleton && selectedMovie && showDateItem ? <div className={styles.listContainer}>
            {
              sessionData && sessionData.searches.length > 0 ?
                sessionData.searches.map((item, idx) => <SessionItem {...item} nationCode={cinemaData?.nationCode} showDate={showDateItem?.label} cinemaName={cinemaData?.name} movieName={selectedMovie?.name} index={`${item?.dfScheduleId}-${idx}`} key={`${item?.dfScheduleId}-${idx}`} keyIndex={idx} click={() => sesstionHandleClick(item, idx)} noBorder={idx === sessionData.searches.length - 1} />)
                :
                <div className={styles.noCiname}>
                  <span>{`${showDateItem?.label}${showDateItem?.date}${TLang('暂无影院排期', 'home', false, false, null)}`}</span>
                  <div onClick={changeToNextDate}>{TLang('看看其他日期', 'home', false, false, null)}</div>
                </div>
            }
          </div> : null
        }
        <PullLoad clientDom=".am-drawer-content" docuDom=".cinemaDetail" hasMore={sessionData && sessionData.hasNext || false} show={sessionData && sessionData.searches.length !== 0} loadMore={loadMoreData} />
      </> : <NavBar initColor="#2B3C4D" text={''} textStyles={{ color: '#999' }} targetColor="#2B3C4D" targetBgColor="#FFF" opacity={1} />
    }
    </div >
    {/** 绑定手机号弹框*/}
    <Modal
      visible={showTicketModal}
      transparent
      closable
      maskClosable={false}
      onClose={() => setShowTicketModal(false)}
      title={TLang('购票说明', 'home', false, false, null)}
      className={styles.ticketModal}
    >
      <div className={styles.desc}>
        {/*<p>*/}
        {/*  {TLang('折扣票', 'home', false, false, null)}*/}
        {/*  <span>{TLang('票价优惠', 'home', false, false, null)}</span>*/}
        {/*  {TLang('，下单支付成功后一般出票时间预计在', 'home', false, false, null)}*/}
        {/*  <span>{TLang('30-60分钟', 'home', false, false, null)}</span>*/}
        {/*  {TLang('。若未成功出票，退款会按原路返回。折扣票订单下单后，订单', 'home', false, false, null)}*/}
        {/*  <span>{TLang('不支持退票、改签。', 'home', false, false, null)}</span>*/}
        {/*</p>*/}
        <p>
          {TLang('折扣票', 'home', false, false, null).replace('-', '')}
          <span>{TLang('票价优惠', 'home', false, false, null).replace('-', '')}</span>
          {TLang('，当前抢票人数较多，请在支付完成后耐心等待出票结果。若未成功出票，退款会按原路返回。折扣票订单下单后，', 'home', false, false, null)}
          <span>{TLang('不支持退票、改签。', 'home', false, false, null)}</span>
        </p>
      </div>
      <div className={styles.footer}>
        <div className={styles.cancle} onClick={() => {
            goToLockTicket(true);
          }}
        >
          {/* <img src={DFfudouImg} alt=""/>
            <span className={styles.price}>{currentSessionInfo?.price2Ratio * 100}</span> */}
          <DfPrice price={currentSessionInfo?.price2} iconCls={'xl'} textStyles={{'fontSize':'0.32rem', 'color':'#fff', 'marginRight':'3px', 'fontWeight': '400'}}/>
          {TLang('去抢折扣票', 'home', false, false, null)}
        </div>
        <div className={styles.confirm} onClick={() => {
            goToLockTicket(false);
          }}
        >
          {getCookie('df_lang')==='en-US' ? null : TLang('不抢,', 'home', false, false, null)}
          <DfPrice price={currentSessionInfo?.price} iconCls={'xl'} textStyles={{'fontSize':'0.32rem', 'color':window?.dffl_global?.allCommonTheme?.globalThemeColor||'#3FA6FF', 'marginRight':'3px', 'fontWeight': '400'}}/>
          {TLang('买普通票', 'home', false, false, null)}
        </div>
      </div>
    </Modal>
  </>;
};
const mapStateToProps = ({ cinema, initData }) => ({ cinemaParams: cinema, ...initData });
export default withRouter(connect(mapStateToProps)(CinemaSessionList));

// export default MovieDetail

